// extracted by mini-css-extract-plugin
module.exports = {"section":"Xn3Ok"};